// extracted by mini-css-extract-plugin
export default {"table-responsive-2":"GeneratePayroll_table-responsive-2__OwwFK"};